import React from "react";
import { FaArrowUp, FaArrowDown, FaMinus } from "react-icons/fa";
import { useTranslation } from "react-i18next";

/**
 * Statistics Overview Component
 * Displays key performance statistics with trend indicators
 */
const StatisticsOverview = ({ statistics }) => {
  const { t } = useTranslation();
  const { totalGames, averageScore, trend } = statistics;

  // Map trend icons
  const TrendIconMap = {
    FaArrowUp: FaArrowUp,
    FaArrowDown: FaArrowDown,
    FaMinus: FaMinus,
  };

  const TrendIcon = TrendIconMap[trend.icon] || FaMinus;
  const rotationClass =
    trend.direction === "stable" ? "" : "transform rotate-45";

  return (
    <div className="grid grid-cols-3 gap-4 justify-items-center items-end bg-primary/80 rounded-xl p-4 border border-primary/30 mb-4">
      {/* Games Played */}
      <div className="flex flex-col items-center">
        <p className="text-2xl sm:text-3xl font-bold text-white">
          {totalGames}
        </p>
        <p className="mt-1 text-xs sm:text-sm text-white uppercase tracking-wide whitespace-nowrap">
          {t("history.stats.games")}
        </p>
      </div>

      {/* Average Score */}
      <div className="flex flex-col items-center">
        <p className="text-2xl sm:text-3xl font-bold text-white">
          {averageScore.toFixed(1)}
        </p>
        <p className="mt-1 text-xs sm:text-sm text-white uppercase tracking-wide whitespace-nowrap">
          {t("history.stats.average")}
        </p>
      </div>

      {/* Trend */}
      <div className="flex flex-col items-center">
        <div className="w-10 h-10 flex items-center justify-center mb-1 rounded-full bg-primary/50 border border-primary/30">
          <TrendIcon className={`w-5 h-5 ${trend.color} ${rotationClass}`} />
        </div>
        <p className="mt-1 text-xs sm:text-sm text-white uppercase tracking-wide whitespace-nowrap">
          {t("history.stats.trend")}
        </p>
      </div>
    </div>
  );
};

export default StatisticsOverview;
